<ng-container *ngIf="datosEmpresaProducto.detalles">
  <div class="calHid" fxLayout="row">
    <mat-form-field>
      <input matInput #inputFecha [matDatepicker]="fechaGenerica" [matDatepickerFilter]="filtroProrroga" (dateChange)="fechaSeleccionada($event)" [(ngModel)]="datosEmpresaProducto.detalles.fechasProrrogas.valorDatePicker">
      <mat-datepicker touchUi #fechaGenerica></mat-datepicker>
    </mat-form-field>
    <div>
      <input placeholder="12hr format (default settings)" aria-label="12hr format" [ngxTimepicker]="horaGenerica" [format]="24" [min]="filtroHoraHoy" id="timepicker" readonly>
      <ngx-material-timepicker [enableKeyboardInput]="true" (timeSet)="horaSeleccionada($event)" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn" [editableHintTmpl]="dialHint" #horaGenerica></ngx-material-timepicker>
      <ng-template #cancelBtn>
        <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.CANCELAR' | translate}}</button>
      </ng-template>
      <ng-template #confirmBtn>
        <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.ACEPTAR' | translate}}</button>
      </ng-template>
      <ng-template #dialHint>
        <b class="fechaSel">{{'SHEDULE2_0.CARDS.FECHAS.FECHA' | translate}}{{datosEmpresaProducto.detalles.fechasProducto[2].fecha | date:"d MMM y" : datosEmpresaProducto.offsetPipe : idiomaActual}}</b>
      </ng-template>
    </div>
  </div>
</ng-container>
<input #imagen type="file" (change)="cambiaLogoCert_paso2($event)" accept="image/*" hidden>
<input #logoEmpresa type="file" (change)="cambiaLogoEmpresa_paso2($event)" accept="image/*" hidden>
<div class="p-20">
  <h2>{{'ACCIONES.TITULO' | translate}}</h2>
  <div fxLayout="row" fxLayoutAlign="space-between start" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">

    <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="48" >
      <ng-container *ngFor="let categoria of categorias; let i = index;" >
        <ng-container *ngIf="categoria.visible">
        <mat-card class="example-card mat-elevation-z4 mb-20" *ngIf="[0,3].includes(i)">
          <mat-card-header>
            <mat-card-title>{{'ACCIONES.CATEGORIAS.' + categoria.id | translate}}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-list>
              <ng-container *ngFor="let accion of categoria.acciones; let last = last;">
                <ng-container *ngIf="accion.visible">
                  <mat-list-item class="hta">
                    <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="w70">
                      <h4>{{'ACCIONES.LISTA.' + accion.id | translate}}</h4>


                      <ng-container *ngIf="accion.switch == undefined">
                        <button mat-mini-fab color="primary" [disabled]="accion.bloqueado" (click)="this[accion.funcion]()">
                          <span class="material-icons-outlined">{{accion.icono}}</span>
                        </button>
                      </ng-container>
                      <ng-container *ngIf="accion.switch != undefined">
                        <mat-slide-toggle (click)="$event.stopPropagation();" (change)="this[accion.funcion]()" [(ngModel)]="accion.switch"></mat-slide-toggle>
                      </ng-container>
                    </div>
                  </mat-list-item>
                  <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                </ng-container>
              </ng-container>
            </mat-list>
          </mat-card-content>
        </mat-card>
      </ng-container>
      </ng-container>
    </div>

    <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="48" >
      <ng-container *ngFor="let categoria of categorias; let i = index;">
      <ng-container *ngIf="categoria.visible">
        <mat-card class="example-card mat-elevation-z4 mb-20" *ngIf="[1,2,4].includes(i)">
          <mat-card-header>
            <mat-card-title>{{'ACCIONES.CATEGORIAS.' + categoria.id | translate}}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-list>
              <ng-container *ngFor="let accion of categoria.acciones; let last = last;">
                <ng-container *ngIf="accion.visible">
                  <mat-list-item class="hta">
                    <ng-container *ngIf="!accion.subFuncion">
                      <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="accion.subFuncion">
                      <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="{{'ACCIONES.SUBACCIONES.TITULO' | translate}}" *ngIf="accion.subFuncion.some(accionActiva)">
                        <mat-icon>add_circle</mat-icon>
                      </button>
                      <mat-icon mat-list-icon *ngIf="!accion.subFuncion.some(accionActiva)">keyboard_arrow_right</mat-icon>
                    </ng-container>
                    <mat-menu #menu="matMenu">
                      <mat-list *ngIf="accion.subFuncion">
                        <ng-container *ngFor="let subAccion of accion.subFuncion">
                          <mat-list-item class="hta" *ngIf="subAccion.activa">
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                              <h4>{{'ACCIONES.SUBACCIONES.' + accion.id + '.' + subAccion.id + '.TITULO' | translate}}</h4>
                              <ng-container *ngIf="subAccion.switch == undefined">
                                <button mat-mini-fab color="accent" (click)="this[subAccion.funcion](accion.id, subAccion.id)" class="ml-20">
                                  <mat-icon>{{subAccion.icono}}</mat-icon>
                                </button>
                              </ng-container>
                              <ng-container *ngIf="subAccion.switch != undefined">
                                <mat-slide-toggle (click)="$event.stopPropagation();" (change)="this[subAccion.funcion](accion.id, subAccion.id)" [(ngModel)]="subAccion.switch"><p *ngIf="subAccion.id=='updateStatusWCP' && !subAccion.switch ">({{'ACCIONES.SUBACCIONES.verWebComPro.ESTA_WPC.ESTA_WPC_NPU'| translate}})</p> <p *ngIf="subAccion.id=='updateStatusWCP' && subAccion.switch ">({{'ACCIONES.SUBACCIONES.verWebComPro.ESTA_WPC.ESTA_WPC_PU'| translate}})</p></mat-slide-toggle>
                              </ng-container>
                            </div>
                          </mat-list-item>
                          <!-- <ng-container *ngIf="subAccion.id=='updateStatusWCP' && !subAccion.switch">
                            <mat-form-field appearance="outline" >
                              <mat-label>Razón</mat-label>
                              <textarea matInput diseabled [(ngModel)]="reason" disabled></textarea>
                            </mat-form-field>
                          </ng-container> -->
                        </ng-container>
                      </mat-list>
                    </mat-menu>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="w70">
                      <h4>{{'ACCIONES.LISTA.' + accion.id | translate}}</h4>
                      <ng-container *ngIf="accion.switch == undefined">
                        <button mat-mini-fab color="primary" [disabled]="accion.bloqueado" (click)="this[accion.funcion]()">
                          <span class="material-icons-outlined">{{accion.icono}}</span>
                        </button>
                      </ng-container>
                      <ng-container *ngIf="accion.switch != undefined">
                        <mat-slide-toggle (click)="$event.stopPropagation();" (change)="this[accion.funcion]()" [(ngModel)]="accion.switch"></mat-slide-toggle>
                      </ng-container>
                    </div>
                  </mat-list-item>
                  <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                </ng-container>
              </ng-container>
            </mat-list>
          </mat-card-content>
        </mat-card>
      </ng-container>
      </ng-container>
    </div>
  </div>
</div>
